import React from "react";
import PropTypes from "prop-types";
import EvaluationQuestion from "../EvaluationQuestion";

const EvaluationQuestions = ({
  isEvaluationCompleted,
  section,
  sectionIndex,
  handleInputChange,
}) => {
  const questions = section?.questions ?? [];
  // Same order for all views: multi first, then text/date; within each group by order (0-based)
  const sortedQuestions = [...questions].sort((a, b) => {
    const aIsMulti = a.answerType === "multi";
    const bIsMulti = b.answerType === "multi";
    if (aIsMulti && !bIsMulti) return -1;
    if (!aIsMulti && bIsMulti) return 1;
    return (a.order ?? 0) - (b.order ?? 0);
  });

  return (
    <React.Fragment>
      {sortedQuestions.map((question, questionIndex) => (
        <EvaluationQuestion
          handleInputChange={handleInputChange}
          isEvaluationCompleted={isEvaluationCompleted}
          key={question.id}
          question={question}
          questionId={question.id}
          questionIndex={questionIndex}
          sectionIndex={sectionIndex}
        />
      ))}
    </React.Fragment>
  );
};

EvaluationQuestions.propTypes = {
  isEvaluationCompleted: PropTypes.bool.isRequired,
  section: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  sectionIndex: PropTypes.number.isRequired,
};

export default EvaluationQuestions;
